var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28598 12.022C5.00168 11.9945 3.88404 11.2986 3.26516 10.2783C3.66634 10.2757 4.06097 10.2282 4.43125 10.1283L4.39993 9.15544C3.00754 8.87419 1.90237 7.79385 1.60462 6.42148C2.00493 6.54825 2.4304 6.6235 2.86314 6.6316L4.5862 6.66389L3.14797 5.71442C2.19343 5.08426 1.55643 3.99763 1.55643 2.77662C1.55643 2.37953 1.62369 1.999 1.7471 1.64132C3.83402 3.86439 6.75373 5.30093 10.0193 5.45819L10.6784 5.48993L10.5306 4.8468C10.4737 4.59908 10.4486 4.3303 10.4486 4.03815C10.4486 2.09476 12.0426 0.5 14.0345 0.5C15.0602 0.5 15.9999 0.929548 16.6586 1.62213L16.8481 1.82127L17.1177 1.76809C17.5592 1.68102 17.9891 1.56285 18.4049 1.41425C18.1624 1.68231 17.878 1.91407 17.561 2.10097L17.8772 3.0278C18.1463 2.99403 18.4123 2.94914 18.6747 2.89313C18.4129 3.14191 18.1329 3.37167 17.8346 3.58068L17.6081 3.7394L17.6222 4.01562C17.6307 4.1819 17.6365 4.34506 17.6365 4.512C17.6365 9.62485 13.6953 15.5 6.49967 15.5C4.99648 15.5 3.56897 15.2104 2.26588 14.6805C3.88252 14.4866 5.36625 13.8558 6.58096 12.9175L7.7013 12.0522L6.28598 12.022Z",
    stroke: "#787676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c537c652aff103a12daf956d8f3c1705.svg";
export { ForwardRef as ReactComponent };